export const whatsappLoadingScreens = [
  {
    icon: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Group_1171276736_6266585dbc.png',
    alt: 'Challan Details',
    text: 'Fetching your challan details...',
  },
  {
    icon: 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Group_1171276735_4f04a96108.png',
    alt: 'unpaid Challans',
    text: 'You have unpaid challans',
  },
]

export const DEFAULT_CAR_MODAL = 'Tata Punch'
export const UNAPID_CHALLANS = 'You have unpaid challans'
export const APP_CHALLANS = 'View Challans on the app'

export const UNABLE_TO_PROCESS_PNG = 'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Unable_to_process_33847606d6.png'
export const RENEWAL_BANNER_IMAGE_PNG =
  'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Group_1171276757_6a8edab3ef.png'
export const UNPAID_CHALLAN_BANNER_PNG =
  'https://acko-cms-dev.s3.ap-south-1.amazonaws.com/Frame_1171281801_5b72e47ddc.png'
export const CHECK_PRICE_URL = '/motororchestrator/api/v1/proposals/challan/'
